/**
 * @flow
 */

export const search = (query: string) => ({
    type: 'SEMINAR.SEARCH',
    query,
});
